import { useRef, useCallback } from 'react';
function useDebounce(callback, delay) {
    const timer = useRef(null);
    const debouncedFunction = useCallback((value) => {
        if (timer.current)
            clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            callback(value);
        }, delay);
    }, [callback, delay]);
    return debouncedFunction;
}
export default useDebounce;
//# sourceMappingURL=useDebounce.js.map